export const SET_LOCALE = 'SET_LOCALE';
export const RESET_LOCALE = 'RESET_LOCALE';
